import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import Swal from "sweetalert2";

const AllServiceRequest = () => { 
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  // For Issue Modal
  const [selectedIssue, setSelectedIssue] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Fetch applications list
  const fetchRequests = async () => {
    try {
      setLoading(true);
      const seller_id = localStorage.getItem("seller_id");

      const res = await axios.get(`${baseurl}getServiceApplicationsByServiceMan/${seller_id}`);
      setRequests(res.data.data || []);
    } catch (error) {
      console.error("Error fetching service requests:", error);
    } finally {
      setLoading(false);
    }
  };

  // Delete a request
  const handleDelete = async (appId) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This service request will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.delete(`${baseurl}deleteServiceApplicationById/${appId}`);
        Swal.fire("Deleted!", "The request has been deleted.", "success");
        fetchRequests();
      } catch (error) {
        Swal.fire("Error", "Failed to delete request.", "error");
      }
    }
  };

  // Update status
  const updateStatus = async (appId, newStatus) => {
    try {
      await axios.put(`${baseurl}updateServiceApplicationStatus/${appId}`, {
        status: newStatus,
      });

      Swal.fire("Updated!", "Status updated successfully.", "success");
      fetchRequests();
    } catch (error) {
      Swal.fire("Error", "Failed to update status.", "error");
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1 mb-3">Service Requests</h4>



 <Link to="/seller/service-team-create" className="btn btn-primary mb-3">
                     Add Service Team
                   </Link>
 
                   <Link to="/seller/service-request" className="btn btn-primary mb-3 ms-3">
                     All Service Requests
                   </Link>


 

                  <div className="card p-3">
                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="table-responsive">
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Customer</th>
                              <th>Contact</th>
                              <th>Instrument</th>
                              <th>Model</th>
                              <th>Issue</th>
                              <th>Document</th>
                              <th>Video</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {requests.length > 0 ? (
                              requests.map((item) => (
                                <tr key={item.id}>
                                  <td>
                                    {item.customer_name}
                                    <br />
                                    <small>{item.customer_email}</small>
                                  </td>

                                  <td>{item.customer_contact}</td>

                                  <td>{item.instrument_name}</td>
                                  <td>{item.model_number}</td>

                                  {/* Issue - show 25 chars only */}
                                  <td
                                    style={{ maxWidth: "200px", cursor: "pointer", color: "blue" }}
                                    onClick={() => {
                                      setSelectedIssue(item.technical_issue);
                                      setShowModal(true);
                                    }}
                                  >
                                    {item.technical_issue?.length > 25
                                      ? item.technical_issue.substring(0, 25) + "..."
                                      : item.technical_issue}
                                  </td>

                                  {/* Document */}
                                  <td>
                                    {item.document_file ? (
                                      <a
                                        href={`${imageUrl}serviceapplications/${item.document_file}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        View
                                      </a>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>

                                  {/* Video */}
                                  <td>
                                    {item.video_file ? (
                                      <a
                                        href={`${imageUrl}serviceapplications/${item.video_file}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Watch
                                      </a>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>

                                  {/* Status Dropdown */}
                                  <td>
                                    <select
                                      className="form-select"
                                      value={item.status}
                                      onChange={(e) =>
                                        updateStatus(item.id, e.target.value)
                                      }
                                    >
                                      <option value="pending">Pending</option>
                                      <option value="approved">Approved</option>
                                      <option value="rejected">Rejected</option>
                                    </select>
                                  </td>

                                  <td>
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => handleDelete(item.id)}
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  No service requests found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
      </div>

      {/* ---------- ISSUE MODAL ---------- */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Technical Issue Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <p style={{ whiteSpace: "pre-line" }}>{selectedIssue}</p>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
      {/* ---------- END MODAL ---------- */}
    </>
  );
};

export default AllServiceRequest;
